export default "__VITE_ASSET__CqOO34Ks__"